<template>
    <div class="shop-item">
        <div class="article-card pb-2" v-for="(item, index) in list.slice(0, PreviewNum)" :key="index"
             @click="handleClick(item)">
                <el-image
                        :src="item.imgUrl"
                        fit="cover"/>
                <div class="mr-3 ml-3">
                    <div class="text-content" v-html="content(item.content)"/>
                    <div class="start text-right" v-if="showHidden">
                        <img src="@/assets/images/heart_line.svg">
                        <span style="margin-left: 4px">{{item.loveCount}}</span>
                    </div>
                </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "ArticleCard",
        props: {
            list: { default: [] },
            PreviewNum: { },
        },
        data() {
            return {
              showHidden: false,
            }
        },
        created() {
        },
        mounted() {

        },
        methods: {
            handleClick(item) {
                this.$router.push({name: 'ArticleDetail', query: {id: item.id}});
            },
            content(text){
                text = text.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
                text = text.replace(/&nbsp;/ig, ''); //去掉&nbsp
                return text.substring(0, 39) + '...'
            }
        }
    }
</script>

<style lang="less" scoped>
    .text-content {
        font-size: 12px;
    }
    .article-card {
        margin: 20px;
        border-radius: 16px;
        box-shadow: var(--box-shadow);
        background: #fff;
        position: relative;
        @media(min-width: 1024px){
            width: 315px;
            margin: 20px 0 5px 20px;
        }
        .el-image{
            border-radius: 10px 10px 0 0;
            overflow: hidden;
            width: 100%;
            height: calc((100vw - 40px) * 0.59);
            @media(min-width: 1024px){
                height: calc((315px - 40px) * 0.59);
            }
        }
        .comment-text {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            width: 100%;
            height: 55px;
            font-size: 18px;
            line-height: 26px;
            /deep/iframe , /deep/img{
                display: none!important;
            }
            &/deep/*{
                display: inline!important;
                font-family: inherit !important;
                font-size: inherit !important;
                font-weight: inherit!important;
                color: inherit!important;
            }
        }

        .start {
            display: flex;
            align-items: center;
            padding-left: 10px;
            justify-content:flex-end;
            img {
                width: 25px;
                height: 22px;
            }
        }
    }
</style>